import { ImageNameEnum as e } from "../image-enum.mjs";
import { imageToFile as t } from "@systemeio/file-manager";
//#region src/extensions/image-extension/use-image-drop-and-upload/utils.ts
var n = (t) => t.type.name === e.Block || t.type.name === e.Inline, r = (e) => n(e) && !!e.attrs?.src && !e.attrs.uploadingProps, i = (e) => e.split("/").pop()?.split("?")[0] || "image", a = (e, t) => /\.\w+$/.test(e) ? e : `${e}.${t.split("/")[1] || "png"}`, o = (e) => e.startsWith("file:///"), s = (e, t) => {
	e.state.doc.descendants((r, i) => n(r) && r.attrs.uploadingProps?.id === t ? (e.dispatch(e.state.tr.delete(i, i + r.nodeSize).setMeta("addToHistory", !1)), !1) : !0);
}, c = async (e) => {
	if (o(e)) return null;
	let n = "image/png";
	try {
		let t = await fetch(e);
		if (!t.ok) throw Error("Failed to fetch image");
		let r = await t.blob(), o = r.type || n, s = a(i(e), o);
		return new File([r], s, { type: o });
	} catch {
		try {
			let r = new Image();
			r.crossOrigin = "anonymous", await new Promise((t, n) => {
				r.onload = t, r.onerror = n, r.src = e;
			});
			let o = a(i(e), n);
			return await t(r, o, n);
		} catch {
			return null;
		}
	}
};
//#endregion
export { a as ensureExtension, i as getFileNameFromUrl, n as isImageNode, o as isLocalFileUrl, r as isValidUploadedImage, c as loadImageFromUrl, s as removeUploadingImage };
